<template>
  <b-modal
    v-model="showModal"
    title="Cheque Details"
    size="lg"
    @hidden="$emit('modal-closed')"
  >
    <b-alert
      variant="danger"
      :show="errorMessage ? true : false"
    >
      <div
        v-if="typeof errorMessage === 'object'"
        class="alert-body"
      >
        <p
          v-for="(message, index) in errorMessage"
          :key="index"
        >
          {{ message }}
        </p>
      </div>
      <p
        v-else
        class="alert-body"
      >
        {{ errorMessage }}
      </p>
    </b-alert>

    <div
      v-if="loading"
      class="text-center"
    >
      <b-spinner
        label="Small Spinner"
        variant="primary"
      />
    </div>
    <div v-if="!loading && !errorMessage">
      <b-table-simple
        responsive
        hover
        class="compact-table"
      >
        <b-tbody>
          <b-tr>
            <b-th> Cheque No. :</b-th>
            <b-td> {{ details.formatted_cheque_number }} </b-td>
            <b-th> Sent Through :</b-th>
            <b-td>
              {{ details.sent_through }}
            </b-td>
            <b-th> Status :</b-th>
            <b-td> <app-chip :variant="getStausChipVariant(details.status)">
              {{ details.status.charAt(0).toUpperCase() + details.status.slice(1) }}
            </app-chip> </b-td>
          </b-tr>
          <b-tr>
            <b-th> Supplier : </b-th>
            <b-td colspan="3">
              {{ details.supplier_identifier }}
            </b-td>
            <b-th> Issue Date :</b-th>
            <b-td>
              {{ details.issue_date && formatedDate(details.issue_date, 'DD-MM-YYYY') || '-' }}
            </b-td>
          </b-tr>
          <b-tr>
            <b-th> Amount : </b-th>
            <b-td> {{ details.amount }} </b-td>
            <b-th> Upto Amount :</b-th>
            <b-td> {{ details.upto_amount }} </b-td>
            <b-th> Created At :</b-th>
            <b-td>
              {{ details.generation_date && formatedDate(details.generation_date, 'DD-MM-YYYY') || '-' }}
            </b-td>
          </b-tr>
          <b-tr v-if="details.status === 'deposited' && details.deposited_on">
            <b-th> Deposited On :</b-th>
            <b-td>
              {{ details.deposited_on && formatedDate(details.deposited_on, 'DD-MM-YYYY') || '-' }}
            </b-td>
          </b-tr>
          <b-tr v-if="details.status === 'cancelled' && details.cancelled_on">
            <b-th> Cancelled On :</b-th>
            <b-td>
              {{ details.cancelled_on && formatedDate(details.cancelled_on, 'DD-MM-YYYY') || '-' }}
            </b-td>
          </b-tr>
          <b-tr v-if="details.status === 'bounced' && details.bounced_on">
            <b-th> Bounced On :</b-th>
            <b-td>
              {{ details.bounced_on && formatedDate(details.bounced_on, 'DD-MM-YYYY') || '-' }}
            </b-td>
          </b-tr>

          <b-tr v-if="details.sent_through === 'MR' && details.mr">
            <b-th> MR Name :</b-th>
            <b-td>
              {{ details.mr }}
            </b-td>
            <b-th> MR Mobile :</b-th>
            <b-td>
              {{ details.mr_mobile }}
            </b-td>
            <b-th> MR Handover Date :</b-th>
            <b-td>
              {{ details.mr_handover_date && formatedDate(details.mr_handover_date, 'DD-MM-YYYY') || '-' }}
            </b-td>
          </b-tr>
          <b-tr v-if="details.sent_through === 'courier'">
            <b-th> Courier Slip :</b-th>
            <b-td colspan="3">
              <a
                v-if="details.courier_slip"
                :href="details.courier_slip"
                target="_blank"
                class="text-primary"
              >
                View File
              </a>
            </b-td>
            <b-th> Docket Number :</b-th>
            <b-td colspan="1">
              {{ details.docket_number || '-' }}
            </b-td>
          </b-tr>
          <b-tr v-if="details.sent_through === 'courier'">
            <b-th> Delivery Boy :</b-th>
            <b-td colspan="1">
              {{ details.delivery_boy_name || '-' }}
            </b-td>
            <b-th> Courier : </b-th>
            <b-td colspan="1">
              {{ details.courier_name || '-' }}
            </b-td>
            <b-th> Courier Date : </b-th>
            <b-td colspan="1">
              {{ details.courier_date && formatedDate(details.courier_date, 'DD-MM-YYYY') || '-' }}
            </b-td>
          </b-tr>
        </b-tbody>
      </b-table-simple>

      <b-form-group label="Remarks">
        <b-form-textarea
          v-model="details.remarks"
          rows="3"
          type="text"
          placeholder="Remarks"
          :disabled="readOnly"
        />
      </b-form-group>
    </div>

    <template #modal-footer="{ ok, cancel }">
      <b-button
        variant="secondary"
        @click="cancel()"
      >
        Close
      </b-button>
    </template>
  </b-modal>
</template>

<script>
import {
  BModal, BSpinner, BButton, BAlert, BTableSimple, BTr, BTh, BTd, BTbody, BFormTextarea, BFormGroup,
} from 'bootstrap-vue'
import axios from 'axios'
import dateMixin from '@/mixins/dateMixin'
import AppChip from '../UI/AppChip.vue'

export default {
  components: {
    BModal,
    BButton,
    BSpinner,
    BAlert,
    BTableSimple,
    BTr,
    BTh,
    AppChip,
    BTd,
    BTbody,
    BFormTextarea,
    BFormGroup,
  },
  mixins: [dateMixin],
  props: {
    id: { type: Number, required: true },
  },
  data() {
    return {
      showModal: true,
      details: {},
      loading: true,
      errorMessage: '',
      attention_closed: false,
      selectedUserId: '',
      operationUsers: [],
      readOnly: false,
    }
  },
  mounted() {
    this.fetchDetails()
  },
  methods: {
    async fetchDetails() {
      try {
        this.loading = true
        const { data } = await axios.get(`/accounts/vatika_cheques/${this.id}`)
        this.details = data
      } catch (error) {
        this.errorMessage = error?.response?.data?.detail || 'Failed to fetch details'
      } finally {
        this.loading = false
      }
    },
    getStausChipVariant(value) {
      if (value === 'cancelled') {
        return 'danger'
      }

      if (value === 'bounced') {
        return 'warning'
      }

      if (value === 'deposited') {
        return 'success'
      }
      if (value === 'security') {
        return 'primary'
      }

      if (value === 'undeposited') {
        return 'secondary'
      }

      return 'secondary'
    },
  },
}
</script>

<style scoped>
label {
  display: block;
  margin-bottom: 0.5rem;
  font-weight: 500;
}
td{
  text-align: start;
}
th{
  width: 55px;
  margin: 0;
  padding:  0;
}
</style>
